import { FC, useState } from "react";
import styles from './AnnoItem.module.less';
import { useNavigate } from "react-router-dom";

const AnnoItem: FC = (props) => {
    const navigate = useNavigate();
    const [hover, setHover] = useState(false);
    const titleStyle = {
        color: '#333',
        fontWeight: 400,
        fontSize: '18px'
    }
    const titleStyleHover = {
        color: '#005BAC',
        fontWeight: 800,
        fontSize: '18px',
        cursor: 'pointer'
    }

    const contentStyle = {
        color: '#666'
    }
    const contentStyleHover = {
        color: '#333'
    }
    return (
        <div className={styles.body}>
            <div className={styles.left}>
                <div className={styles.id}>{props.time ? props.time.slice(-2) : ''}</div>
                <div className={styles.date}>{props.time ? props.time?.slice(0, 7) : ''}</div>
            </div>
            <div onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} className={styles.right}>
                <div style={hover ? titleStyleHover : titleStyle} onClick={() => navigate(`/notification/${props.id}`)} className={styles.title}>
                    {props.title ? props.title : ''}
                </div>
                <div style={hover ? contentStyleHover : contentStyle} className={styles.content}>
                    {props.content ? props.content.replace(/<.*?>/g,'').replace(/&nbsp;/g, '') : ''}
                </div>
            </div>
        </div>
    );
}

export default AnnoItem;